import RejectDialog from './RejectDialog';

const ReasonDialog = ({ checklistData, handler, open, setOpen }: any) => {
  const metadata = checklistData?.metadata ? JSON.parse(checklistData?.metadata) : {};
  const { title, message, catalogReason, reasonIsRequired, reasonNoteRequired } =
    metadata?.ui?.data?.reason ?? {};

  return (
    <RejectDialog
      isOpen={open}
      handlerReject={(data: any) => {
        handler({
          reason: data?.reason,
          reasonNote: data?.reasonNote,
        });
      }}
      handlerIsOpenConfirmDialog={() => setOpen(false)}
      rejectCounty={false}
      dataHandler={{
        title: title,
        message: message,
        dispositionCatalogCode: catalogReason,
        dispositionReasonIsRequired: reasonIsRequired,
        dispositionReasonNoteIsRequired: reasonNoteRequired,
      }}
    />
  );
};

export default ReasonDialog;
